import { render, staticRenderFns } from "./UpdateCenterPage.vue?vue&type=template&id=30340a7b&scoped=true"
import script from "./UpdateCenterPage.vue?vue&type=script&lang=js"
export * from "./UpdateCenterPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30340a7b",
  null
  
)

export default component.exports